// ---------------------------------------------------------------------------
// Minimal client-side router hooks
// Compatible with our window.location-based router in main.tsx
// ---------------------------------------------------------------------------

/**
 * Returns a function to navigate to a path (replaces window.location.href).
 */
export function useNavigate() {
  return async ({ to }: { to: string }) => {
    window.location.href = to;
  };
}

/**
 * Parses dynamic path params from the current URL.
 * Supports patterns like /ingredients/:id/edit → { id }
 *
 * Usage: const { id } = useParams({ pattern: '/ingredients/:id/edit' })
 */
export function useParams(_opts: { strict?: boolean } = {}): Record<string, string> {
  const path = window.location.pathname;

  // Match /something/:id/edit
  const editMatch = path.match(/^\/[^/]+\/([^/]+)\/edit$/);
  if (editMatch?.[1]) return { id: editMatch[1] };

  // Match /something/:id
  const detailMatch = path.match(/^\/[^/]+\/([^/]+)$/);
  if (detailMatch?.[1]) return { id: detailMatch[1] };

  return {};
}
